import { cn } from "@/lib/utils";
import { formatBrDateTime } from "@/utils/br-datetime";
import { Icon } from "@/components/ui/icon"

type EventCheckInDoneCardProps = {
  checkedInAt: string;
  className?: string;
};

export function EventCheckInDoneCard({
  checkedInAt,
  className,
}: EventCheckInDoneCardProps) {
  const checkedInLabel = formatBrDateTime(checkedInAt, {
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <div
      className={cn(
        "w-full bg-card-surface p-8 rounded-xl border border-card-border shadow-xl shadow-black/5 dark:shadow-none",
        className)}
    >
      <div className="flex items-start gap-4">
        <div className="w-11 h-11 rounded-full bg-emerald-500/10 text-emerald-600 shrink-0 flex items-center justify-center">
          <Icon name="where_to_vote" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-text-muted text-sm font-medium mb-2">Check-in</p>
          <p className="text-foreground text-xl font-bold">Presença confirmada</p>
          <p className="text-text-muted text-sm mt-1">{checkedInLabel}</p>
        </div>
      </div>
    </div>
  );
}
